import FeaturedCities from './FeaturedCities';

export default FeaturedCities;
